<template>
  <div>
    <Row :gutter="10">
      <i-col :md="24" :lg="24" style="margin-bottom: 10px;">
        <Card>
          <Alert banner closable>搜索支持全局搜索，多条件搜索时请使用“|”作为条件分隔符</Alert>
          <div class="search-con search-con-top">
            <Input class="search-input" v-model="searchVal" style="padding:5px;" placeholder="输入关键字全局搜索" @on-enter="searchinput"/>
            <slot name="new_btn">
              <Button type="primary" @click="editModal('', 'post', '添加退役军人信息')" class="search-btn">添加信息</Button>
            </slot>
            <Button type="error" class="search-btn" @click="handlerDelete">批量删除</Button>

          </div>
          <Spin size="large" fix v-if="spinShow"></Spin>
          <Table v-loading.fullscreen.lock="fullscreenLoading" height="670" size="small" ref="selection" border :columns="columns" :data="tableData"
                 @on-selection-change="handleSelectChange"></Table>
          <div style="margin: 10px; overflow: hidden">
            <div style="float: left;">
              <Page :total="pageTotal" :current="pageNum" :page-size="pageSize" :page-size-opts=[15,35,50,100]
                    show-sizer show-total @on-change="changePage" @on-page-size-change="handlePageSize">
              </Page>
            </div>
          </div>
          <Modal v-model="modalMap.modalVisible" :title="modalMap.modalTitle" :loading=true :footer-hide=true
                 :mask-closable=false>
            <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">

              <FormItem
                label="姓名"
                prop="Pname"
              >
                <Input
                  v-model="formValidate.Pname"
                  placeholder="请输入姓名"
                  disabled
                  v-if="formValidate.Id != 0"
                ></Input>
                <Input
                  v-model="formValidate.Pname"
                  placeholder="请输入姓名"
                  v-if="formValidate.Id == 0"
                ></Input>
              </FormItem>
              <FormItem label="性别" prop="Psex">
                <el-select
                  v-model="formValidate.Psex"
                  filterable
                  default-first-option
                  placeholder="请选择">
                  <el-option
                    v-for="item in PsexList"
                    :key="item.value"
                    :label="item.meaning"
                    :value="item.value">
                  </el-option>
                </el-select>

              </FormItem>
              <FormItem label="类别" prop="Pstype">
                <el-select
                  v-model="formValidate.Pstype"
                  filterable
                  default-first-option
                  placeholder="请选择">
                  <el-option
                    v-for="item in PstypeList"
                    :key="item.value"
                    :label="item.meaning"
                    :value="item.value">
                  </el-option>
                </el-select>

              </FormItem>
              <FormItem
                label="身份证"
                prop="Pidcard"
              >
                <Input
                  v-model="formValidate.Pidcard"
                  placeholder="请输入"
                ></Input>
              </FormItem>
              <FormItem label="户籍地址" prop="Paddress">
                <Input
                  v-model="formValidate.Paddress"
                  placeholder="请输入"
                ></Input>
              </FormItem>
              <FormItem label="现居住区域" prop="Pnowaddress">
                <Input
                  v-model="formValidate.Pnowaddress"
                  placeholder="请输入"
                ></Input>
              </FormItem>
              <FormItem label="联系电话" prop="Pphone">
                <Input
                  v-model="formValidate.Pphone"
                  placeholder="请输入"
                ></Input>
              </FormItem>
              <FormItem label="婚姻状况" prop="Pmarriage">
                <el-select
                  v-model="formValidate.Pmarriage"
                  filterable
                  allow-create
                  default-first-option
                  placeholder="请选择，如果没有合适的类型可以自己创建">
                  <el-option
                    v-for="item in PmarriageList"
                    :key="item.value"
                    :label="item.meaning"
                    :value="item.value">
                  </el-option>
                </el-select>

              </FormItem>

              <FormItem label="民族" prop="Pnation">
                <el-select
                  v-model="formValidate.Pnation"
                  filterable
                  allow-create
                  default-first-option
                  placeholder="请选择，如果没有合适的类型可以自己创建">
                  <el-option
                    v-for="item in PnationList"
                    :key="item.value"
                    :label="item.meaning"
                    :value="item.value">
                  </el-option>
                </el-select>

              </FormItem>
              <FormItem label="学历" prop="Peducation">
                <el-select
                  v-model="formValidate.Peducation"
                  filterable
                  allow-create
                  default-first-option
                  placeholder="请选择，如果没有合适的类型可以自己创建">
                  <el-option
                    v-for="item in PeducationList"
                    :key="item.value"
                    :label="item.meaning"
                    :value="item.value">
                  </el-option>
                </el-select>
              </FormItem>
              <FormItem label="工作经验" prop="Pexperience">
                <el-select
                  v-model="formValidate.Pexperience"
                  filterable
                  allow-create
                  default-first-option
                  placeholder="请选择，如果没有合适的类型可以自己创建">
                  <el-option
                    v-for="item in PexperienceList"
                    :key="item.value"
                    :label="item.meaning"
                    :value="item.value">
                  </el-option>
                </el-select>
              </FormItem>
              <FormItem label="期望薪资" prop="Psalary">
                <el-select
                  v-model="formValidate.Psalary"
                  filterable
                  allow-create
                  default-first-option
                  placeholder="请选择，如果没有合适的类型可以自己创建">
                  <el-option
                    v-for="item in PsalaryList"
                    :key="item.value"
                    :label="item.meaning"
                    :value="item.value">
                  </el-option>
                </el-select>
              </FormItem>

              <FormItem
                label="备注"
                prop="Remark"
              >
                <Input
                  type="textarea"
                  v-model="formValidate.Remark"
                  placeholder="请输入"
                ></Input>
              </FormItem>
              <FormItem>
                <Button
                  type="primary"
                  @click="handleSubmit('formValidate')"
                >提交
                </Button>
                <Button
                  @click="handleReset('formValidate')"
                  style="margin-left: 8px"
                >重置
                </Button>
              </FormItem>

            </Form>
          </Modal>
        </Card>
      </i-col>
    </Row>
    <Spin size="large" fix v-if="spinShow"></Spin>
    <el-drawer
      title="个人信息"
      :visible.sync="msgmodal"
      direction="ltr"
      size="30%">
      <el-divider></el-divider>

      <el-form ref="form" :model="formValidate_per" label-width="100px">

        <el-form-item label="姓名：">
          {{ formValidate_per.Pname }}
        </el-form-item>
        <el-form-item label="性别：">
          {{ formValidate_per.Psex_CN }}
        </el-form-item>
        <el-form-item label="年龄：">
          {{ formValidate_per.age }}
        </el-form-item>
        <el-form-item label="身份证：">
          {{ formValidate_per.Pidcard }}
        </el-form-item>
        <el-form-item label="类型：">
          {{ formValidate_per.Pstype_CN }}
        </el-form-item>
        <el-form-item label="地址：">
          {{ formValidate_per.Paddress }}
        </el-form-item>
        <el-form-item label="现居住区域：">
          {{ formValidate_per.Pnowaddress }}
        </el-form-item>
        <el-form-item label="电话：">
          {{ formValidate_per.Pphone }}
        </el-form-item>
        <el-form-item label="婚姻：">
          {{ formValidate_per.Pmarriage_CN }}
        </el-form-item>
        <el-form-item label="民族：">
          {{ formValidate_per.Pnation_CN }}
        </el-form-item>
        <el-form-item label="学历：">
          {{ formValidate_per.Peducation_CN }}
        </el-form-item>
        <el-form-item label="工作年限：">
          {{ formValidate_per.Pexperience_CN }}
        </el-form-item>

        <el-form-item label="期望薪酬：">
          {{ formValidate_per.Psalary_CN }}
        </el-form-item>
        <el-form-item label="简历：">
          <el-image
            style="width: 100px; height: 100px"
            :src="formValidate_per.perpic"
            :preview-src-list="formValidate_per.perpiclist">
          </el-image>
        </el-form-item>
      </el-form>
    </el-drawer>
  </div>
</template>

<script>

  import {
    getPersonlist,
    operationPerson
  } from '@/api/person/person.js'

  import { getsysparameterList } from '@/api/system/sys_parameter'

  // import {Notification} from 'element-ui';

  let moment = require('moment')
  export default {

    data () {
      return {
        spinShow: false,
        fullscreenLoading: false,
        PsexList: [],
        PmarriageList: [],
        PstypeList: [],
        PnationList: [],
        PeducationList: [],
        PexperienceList: [],
        PsalaryList: [],
        formValidate: {},
        searchVal: '',
        tableData: [],
        modalMap: {
          modalVisible: false,
          modalTitle: '新建'
        },
        tableSelectIdList: [],
        editModalData: '',
        pageNum: 1, // 当前页码
        pageTotal: 0, // 数据总数
        pageSize: 15, // 每页条数
        msgmodal: false,
        formValidate_per: {},
        ruleValidate: {
          // admin_user: [{ required: true, message: "请选择管理用户", trigger: "change"}],
          Pname: [
            {
              required: true,
              message: '姓名不能为空',
              trigger: 'blur'
            }
          ],
          Pidcard: [
            {
              required: true,
              message: '身份证不能为空',
              trigger: 'blur'
            }
          ],
          Psex: [
            {
              required: true,
              message: '请选择',
              trigger: 'change'
            }
          ],
          Pmarriage: [
            {
              required: true,
              message: '请选择',
              trigger: 'change'
            }
          ],
          Pstype: [
            {
              required: true,
              message: '请选择',
              trigger: 'change'
            }
          ],
          Pnation: [
            {
              required: true,
              message: '请选择',
              trigger: 'change'
            }
          ],
          Peducation: [
            {
              required: true,
              message: '请选择',
              trigger: 'change'
            }
          ],
          Pexperience: [
            {
              required: true,
              message: '请选择',
              trigger: 'change'
            }
          ],
          Psalary: [
            {
              required: true,
              message: '请选择',
              trigger: 'change'
            }
          ]

        },
        columns: [
          {
            type: 'selection',
            key: 'id',
            width: 60,
            fixed: 'left',
            align: 'center'
          },
          {
            title: '姓名',
            key: 'Pname',
            width: 100,
            align: 'center',
            fixed: 'left',
            sortable: true,
            render: (h, params) => {
              return h('a', {
                  on: {
                    click: () => {
                      this.perinfo_show(params.row)
                    }
                  }
                }, params.row.Pname
              )
            }
          },
          {
            title: '性别',
            key: 'Psex_CN',
            width: 80,
            align: 'center',
            sortable: true
          },
          {
            title: '身份证',
            key: 'Pidcard',
            width: 180,
            align: 'center',
            sortable: true
          },
          {
            title: '类别',
            key: 'Pstype_CN',
            width: 120,
            align: 'center',
            sortable: true
          },
          {
            title: '地址',
            key: 'Paddress',
            width: 200,
            align: 'center',
            sortable: true
          },
          {
            title: '现居住区域',
            key: 'Pnowaddress',
            width: 120,
            align: 'center',
            sortable: true
          },
          {
            title: '联系电话',
            key: 'Pphone',
            width: 150,
            align: 'center',
            sortable: true
          },
          {
            title: '婚姻状况',
            key: 'Pmarriage_CN',
            width: 110,
            align: 'center',
            sortable: true
          },
          {
            title: '民族',
            key: 'Pnation_CN',
            width: 100,
            align: 'center',
            sortable: true
          },
          {
            title: '学历',
            key: 'Peducation_CN',
            width: 100,
            align: 'center',
            sortable: true
          },
          {
            title: '工作经验',
            key: 'Pexperience_CN',
            width: 130,
            align: 'center',
            sortable: true
          },
          {
            title: '期望薪资',
            key: 'Psalary_CN',
            width: 130,
            align: 'center',
            sortable: true
          },
          {
            title: '来源',
            key: 'Ptype_CN',
            width: 100,
            align: 'center',
            sortable: true
          },
          {
            title: '状态',
            key: 'Pstate_CN',
            width: 100,
            fixed: 'right',
            align: 'center',
            sortable: true
          },

          {
            title: '操作',
            key: 'handle',
            fixed: 'right',
            width: 150,
            align: 'center',
            render: (h, params) => {
              return h('div', [
                  h(
                    'Button',
                    {
                      props: {
                        type: 'primary',
                        size: 'small'
                      },
                      style: {
                        marginRight: '5px'
                      },
                      on: {
                        click: () => {
                          this.editModal(params.row, 'put', '修改')
                        }
                      }
                    },
                    '编辑'
                  ),

                h(
                  'Button',
                  {
                    props: {
                      type: 'error',
                      size: 'small'
                    },
                    style: {
                      marginRight: '5px'
                    },
                    on: {
                      click: () => {
                        this.delData(params)
                      }
                    }
                  },
                  '删除'
                )
                ])
              }

          }
        ]
      }
    },
    methods: {

      perinfo_show (val) {
        this.msgmodal = true
        this.formValidate_per = val
      },

      getPersonlist (key, value) {
        this.spinShow = true
        value = 'soldier'
        getPersonlist(this.pageNum, this.pageSize, key, value).then(res => {
          if (res.data.code === 0) {
            this.pageTotal = res.data.count
            this.tableData = res.data.data
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
          this.spinShow = false
        })
      },

      // table 选中的ID
      handleSelectChange (val) {
        let SelectIdList = []
        val.forEach(item => {
          SelectIdList.push(item.Id)
        })

        this.tableSelectIdList = SelectIdList
      },

      closeModal () {
        this.dialog.show = false
      },
      getSYSparameterList () {
        getsysparameterList('person_info', 'Psex').then(res => {
          if (res.data.code === 0) {
            this.PsexList = res.data.data
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
        })
        getsysparameterList('person_info', 'Pmarriage').then(res => {
          if (res.data.code === 0) {
            this.PmarriageList = res.data.data
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
        })
        getsysparameterList('person_info', 'Pstype').then(res => {
          if (res.data.code === 0) {
            this.PstypeList = res.data.data
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
        })
        getsysparameterList('person_info', 'Pnation').then(res => {
          if (res.data.code === 0) {
            this.PnationList = res.data.data
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
        })
        getsysparameterList('person_info', 'Peducation').then(res => {
          if (res.data.code === 0) {
            this.PeducationList = res.data.data
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
        })
        getsysparameterList('person_info', 'Pexperience').then(res => {
          if (res.data.code === 0) {
            this.PexperienceList = res.data.data
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
        })
        getsysparameterList('person_info', 'Psalary').then(res => {
          if (res.data.code === 0) {
            this.PsalaryList = res.data.data
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
        })
        getsysparameterList('person_info', 'Pnation').then(res => {
          if (res.data.code === 0) {
            this.PnationList = res.data.data
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
        })
      },

      editModal (paramsRow, meth, mtitle) {
        this.modalMap.modalVisible = true
        this.modalMap.modalTitle = mtitle
        this.editModalData = meth
        this.getSYSparameterList()
        if (paramsRow && paramsRow.Id) {
          this.formValidate = {
            Id: paramsRow.Id,
            Pname: paramsRow.Pname,
            Psex: paramsRow.Psex.toString(),
            Pidcard: paramsRow.Pidcard,
            Paddress: paramsRow.Paddress,
            Pphone: paramsRow.Pphone,
            Pmarriage: paramsRow.Pmarriage.toString(),
            Pnation: paramsRow.Pnation.toString(),
            Peducation: paramsRow.Peducation.toString(),
            Pexperience: paramsRow.Pexperience.toString(),
            Psalary: paramsRow.Psalary.toString(),
            Remark: paramsRow.Remark,
            Pnowaddress: paramsRow.Pnowaddress,
            Pstype: paramsRow.Pstype.toString(),
            Psoldier: 1
          }
        } else {
          this.formValidate = {
            Id: 0,
            Pname: '',
            Psex: '',
            Pidcard: '',
            Paddress: '',
            Pphone: '',
            Pmarriage: '',
            Pnation: '',
            Peducation: '',
            Pexperience: '',
            Psalary: '',
            Remark: '',
            Pnowaddress: '',
            Pstype: '',
            Psoldier: 1
          }
        }
      },
      handleSubmit (value) {
        this.$refs[value].validate((valid) => {
          if (valid) {
            setTimeout(() => {
              this.formValidate_per.Psoldier = 1
              operationPerson(this.formValidate, this.editModalData).then(res => {
                if (res.data.code === 0) {
                  this.$Message.success(`${res.data.msg}`)

                  if (this.searchVal) {
                    this.getPersonlist(this.searchVal)
                  } else {
                    this.getPersonlist()
                  }
                  this.modalMap.modalVisible = false
                } else {
                  this.$Message.error(`${res.data.msg}`)
                }
              })
            }, 1000)
            // this.$Message.success('Success!');
          } else {
            this.$Message.error('缺少必要参数')
          }
        })
      },

      handleReset (name) {
        this.$refs[name].resetFields()
      },

      handlerDelete () {
        // console.log(this.tableSelectIdList.length)
        if (this.tableSelectIdList.length > 0) {
          if (confirm(`确定要批量删除选中求职者嘛？ `)) {
            operationPerson({ 'id_list': this.tableSelectIdList }, 'delete').then(
              res => {
                if (res.data.code === 0) {
                  this.$Message.success(`${res.data.msg}`)
                  this.getPersonlist(this.searchVal)
                } else {
                  this.$Message.error(`${res.data.msg}`)
                }
              })
          }
        } else {
          this.$Message.info(`你总要选中点什么吧`)
        }
      },
      // 删除
      delData (params) {
        if (confirm(`确定要删除 ${params.row.Pname}`)) {
          // console.log(params.row.id)
          operationPerson(
            {
              'Id': params.row.Id
            },
            'delete'
          ).then(res => {
            if (res.data.code === 0) {
              this.$Message.success(`${res.data.msg}`)
              this.tableData.splice(params.index, 1)
            } else {
              this.$Message.error(`${res.data.msg}`)
            }
          })
        }
      },

      // 点击节点
      // 翻页
      changePage (value) {
        this.pageNum = value
        if (this.searchVal) {
          this.getPersonlist(this.searchVal)
        } else {
          this.getPersonlist()
        }
      },
      // 切换分页
      handlePageSize (value) {
        this.pageSize = value
        this.pageNum = 1
        if (this.searchVal) {
          this.getPersonlist(this.searchVal)
        } else {
          this.getPersonlist()
        }
      },
      searchinput () {
        if (this.searchVal) {
          this.getPersonlist(this.searchVal)
        } else {
          this.getPersonlist()
        }
      }
    },

    watch: {
      searchVal (val) {
        this.searchVal = val
        // this.getServerList(this.searchVal)
      }
    },
    mounted () {
      this.getPersonlist()
    }
  }

</script>

<style lang="css" >
.el-drawer {
  overflow: auto;
}
</style>

<style lang="less" scoped>

  .search-con {
    padding: 10px 0;

    .search {
      &-col {
        display: inline-block;
        width: 200px;
      }

      &-input {
        display: inline-block;
        width: 200px;
        margin-left: 2px;
      }

      &-btn {
        margin-left: 2px;
      }
    }
  }
</style>
